import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchPRofileData } from '../reduxactions/medicalofficeractions/MOProfileActions';
import { DAPPROVER_API, MEOFFICER_API, SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { UploadImageData } from '../reduxactions/medicalofficeractions/MOProfileActions';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { getCountry, getcountryname, getState } from '../reduxactions/suprivisoractions/SuprivisorProfileActions';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';


export const MedicalOfficerProfile = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const [activeIndex, setActiveIndex] = useState(0);
    const options = ['Personal Info', 'Hospital Info'];
    const [value, setValue] = useState(options[0]);


    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.mprofile.data);
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [pincode, setPincode] = useState('');








    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchPRofileData(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync();
    }, [dispatch]);
    const imagess = useSelector((state: RootState) => state.mprofile.image);
    const [selectedFile, setselectedFile] = useState<File | null>(null);

    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setselectedFile(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };

    //To get data
    const fetchDataAsync = async () => {
        try {
            const payload = { uid: uid };
            const apiname = MEOFFICER_API.mprofile;
            const response = await LoginService.getData(apiname, payload);
            setFirstName(response[0].firstName);
            setLastname(response[0].lastName);
            setEmail(response[0].email);
            setPhone(response[0].phone);
            setCountry(response[0].country);
            setState(response[0].state);
            setCity(response[0].city);
            setAddress(response[0].address);
            setPincode(response[0].pin);




            const country = response[0].country;
            if (country && country.length > 0) {
                fetchstate(country);
                getcountryvalue(country);
            }





        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //get country state
    const countrydata = useSelector((state: RootState) => state.sprofile.country);
    const statedata = useSelector((state: RootState) => state.sprofile.state);
    const name = useSelector((state: RootState) => state.sprofile.name);
    const hcountryname = useSelector((state: RootState) => state.sprofile.hcountry);



    useEffectOnce(() => {
        const fetchcountry = async () => {
            try {
                await dispatch(getCountry() as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchcountry();
        fetchDataAsync();
    }, [dispatch]);





    const getcountryvalue = async (country: any) => {
        try {
            await dispatch(getcountryname(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const fetchstate = async (country: any) => {
        try {
            await dispatch(getState(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const toast1 = useRef<Toast>(null);

    const getAddressData = async () => {
        try {
            const payload = { address: address, uid: uid, q: 1 };
            const apiname = SUPRIVISOR_API.verifyadd;
            const data = await LoginService.getData(apiname, payload);

            if (data) {
                setAddress(data);
                if (toast1.current) {
                    toast1.current.show({ severity: 'success', detail: data });
                }
            } else {
                setAddress('')
                console.warn('Invalid or empty response:', data);
            }
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const toast = useRef<Toast>(null);

    const updateProfilePersonal = async () => {
        try {
            const payload = { phone: phone, address: address, city: city, country: country, state: state, name: firstname, lname: lastname, email: email, pin: pincode, uid: uid };
            const apiname = DAPPROVER_API.daupdateprofile_API;
            const data = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: data });
            }
            fetchDataAsync();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/medicalofficerprofile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="col-16" style={{ textAlign: "right" }}>
                        <a
                            title="help"
                            onClick={(e) => openWindow(e, IUrl)}
                            style={{

                                color: "blue",
                                fontSize: 15, cursor: "pointer"
                            }}
                        >Help for this Page &nbsp;
                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                        </a>
                    </div>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="grid">

                                {data.map((response: any) =>
                                    <div className="col-3">
                                        <Card
                                            header=""
                                            style={{
                                                width: '300px',
                                                borderTop: '3px solid #007bff',
                                                textAlign: 'center',
                                                borderRadius: '4px',
                                                marginTop: '-10px',
                                                marginLeft: '20px'
                                            }}
                                        >
                                            <div>
                                                <img
                                                    src={response.photo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '110px',
                                                        height: '86px',
                                                        padding: '3px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%',
                                                        border: '2px solid #adb5bd',
                                                    }}
                                                />
                                            </div>

                                            <h3
                                                className="widget-user-username"
                                                style={{
                                                    color: 'black',
                                                    fontSize: '25px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                    marginTop: '20px'
                                                }}
                                            >
                                                {response.firstName}
                                            </h3>

                                            <h2
                                                className="widget-user-username"
                                                style={{
                                                    color: '#6c757d',
                                                    fontSize: '20px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                }}
                                            >
                                                Medical Officer
                                            </h2>

                                            <FileUpload
                                                mode="basic"
                                                id="fileToUpload"
                                                name="fileToUpload"
                                                customUpload
                                                accept="image/*"
                                                maxFileSize={1000000}
                                                uploadHandler={UploadManagerImage}
                                                auto
                                            />
                                            {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}

                                        </Card>
                                        <Card header="" style={{ width: '300px', marginTop: '20px', marginLeft: '20px' }}>
                                            <div className="widget-user-header bg-info" style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '115%', marginLeft: '-20px', marginTop: '-40px', borderTopLeftRadius: '3px', borderTopRightRadius: '3px' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <h2 className="widget-user-username" style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px', marginLeft: '50px' }}>
                                                        {response.region}
                                                    </h2>

                                                </div>
                                            </div>
                                            <div className='grid' style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                <strong style={{ width: '100px' }}>Address</strong>
                                                <p className="text-muted" style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                                                    {response.address}
                                                </p>
                                            </div>
                                            <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong style={{ width: '100px' }}>City</strong>
                                                <p className="text-muted" style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                                                    {response.city}
                                                </p>
                                            </div>
                                            <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong style={{ width: '100px' }}>State</strong>
                                                <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                                                    {response.statename}
                                                </p>
                                            </div>
                                            <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong style={{ width: '100px' }}>Country</strong>
                                                <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                                                    {response.countryname}
                                                </p>
                                            </div>
                                            <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong style={{ width: '100px' }}>Pin</strong>
                                                <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                                                    {response.pin}
                                                </p>
                                            </div>

                                        </Card>

                                    </div>
                                )}
                                {data.map((response: any) =>
                                    <div style={{ marginTop: '0px', marginRight: '0px' }}>
                                        <div className='col-2'></div>
                                        <div className='col-2'></div>
                                        <div>
                                            {/* <Card  className="profile-header" style={{ width: '700px', marginLeft: '130px', marginTop: '-30px' }}> */}
                                            <div className="grid" style={{ marginLeft: '50px' }}>
                                                <div className="col-12">


                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start' }}>FirstName:</label>
                                                        <InputText id="nameoforg" type="text" placeholder="Enter Name" value={firstname} onChange={(e) => setFirstName(e.target.value)} style={{ flex: 1, marginLeft: '-30px', width: '35vw' }} disabled />
                                                    </div>
                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>LastName:</label>
                                                        <InputText id="nameoforg" type="text" placeholder="Enter Name" value={lastname} onChange={(e) => setLastname(e.target.value)} style={{ flex: 1, marginLeft: '-30px', width: '35vw' }} disabled />
                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>E-Mail:</label>
                                                        <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '-30px' }} />
                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>Phone Number:</label>
                                                        <InputText id="phone" type="number" placeholder="Enter Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ flex: 1, marginLeft: '-30px' }} />

                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>Country:</label>

                                                        <Dropdown id="country" value={country} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={name} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '-30px' }} />
                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>State:</label>
                                                        <Dropdown id="country" value={state} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '-30px' }} />
                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>City:</label>
                                                        <InputText id="phone" type="text" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} style={{ flex: 1, marginLeft: '-30px' }} />
                                                    </div>

                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>Address:</label>
                                                        <InputText id="phone" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ flex: 1, marginLeft: '-30px' }} />
                                                        {/* <i className="pi pi-map-marker" onClick={getAddressData} style={{ fontSize: '2em', cursor: 'pointer' }}></i> */}
                                                    </div>
                                                    <div className="flex align-items-center mb-3">
                                                        <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'start', paddingRight: '20px' }}>Pincode:</label>
                                                        <InputText id="phone" type="text" placeholder="Enter Pincode" value={pincode} onChange={(e) => setPincode(e.target.value)} style={{ flex: 1, marginLeft: '-30px' }} />

                                                    </div>

                                                </div>
                                                <div className="card-footer" style={{ textAlign: 'center' }}>
                                                    <div className="flex justify-content-end">

                                                        <Button label="Update" className="p-button-primary" onClick={updateProfilePersonal} />
                                                    </div>
                                                </div>

                                            </div>
                                            {/* </Card> */}




                                        </div>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <Toast ref={toast} ></Toast>
            <Toast ref={toast1} ></Toast>
        </div>

    )
}
